import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import TablePaginationActions from './TablePaginationActions';

import { makeStyles, Theme } from '@material-ui/core/styles';

interface Props {
  count: number;
  pageCount: number;
  pageIndex: number;
  pageSize: number;
  gotoPage: (updater: ((pageIndex: number) => number) | number) => void;
  setPageSize: (pageSize: number) => void;
  colSpan: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  noBottomBorder: { borderBottom: 0 },
}));

const TablePaginationFooter = ({
  count,
  pageCount,
  pageIndex,
  pageSize,
  setPageSize,
  gotoPage,
  colSpan,
}: Props) => {
  const classes = useStyles();

  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={colSpan} className={classes.noBottomBorder}>
          <TablePagination
            component="div"
            ActionsComponent={TablePaginationActions}
            count={count}
            page={count === 0 ? 0 : pageIndex}
            onChangePage={(ev, newPage) => gotoPage(newPage)}
            onChangeRowsPerPage={(ev) => {
              gotoPage(0);
              setPageSize(parseInt(ev.target.value));
            }}
            rowsPerPage={pageSize}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            labelDisplayedRows={({ from, to, count }) => {
              if (count === 0) return 'データがない';
              return `ページ：${
                pageIndex + 1
              } / ${pageCount}　|　${from} - ${to} / ${count}`;
            }}
            SelectProps={{ native: true }}
          />
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default TablePaginationFooter;
